export default __webpack_public_path__ + "static/media/pp-w-5.1020ce10.svg";